import { render } from "./itm-receipt.vue?vue&type=template&id=7d28aa10&scoped=true"
import script from "./itm-receipt.vue?vue&type=script&lang=js"
export * from "./itm-receipt.vue?vue&type=script&lang=js"

import "./itm-receipt.vue?vue&type=style&index=0&id=7d28aa10&scoped=true&lang=css"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d28aa10"]])

export default __exports__